import {Component, OnInit, Input, ViewChild, ViewChildren, ChangeDetectorRef, EventEmitter, Output, ElementRef} from '@angular/core';
import {WindowRefService, PanierService} from '@app/core';
import {NguCarousel, NguCarouselConfig} from '@ngu/carousel';
import {TruncatePipe} from '../../../core/services/transform.pipe'
@Component({
    selector: 'app-offert',
    templateUrl: './offert.component.html',
    styleUrls: ['./offert.component.scss']
})
export class OffertComponent implements OnInit {
    @ViewChild('myCarousel') myCarousel: NguCarousel<any>;
    @ViewChildren('linkRef') linkRefs;
    @Output() selectRoomEvent = new EventEmitter<number>();

    carouselConfig: NguCarouselConfig = {
        grid: {xs: 1, sm: 1, md: 2, lg: 2, all: 0},
        load: 2,
        interval: null,
        loop: false,
        touch: true,
        velocity: 0,
        point: {
            visible: true
        },
    }
    @Input() offresite;
    @Input() selectedItem: number;

    constructor(private winRef: WindowRefService, private cdr: ChangeDetectorRef, private panierService: PanierService) {}

    ngOnInit() {
    }
    getBaseUrlImg(size: string): string {
        return this.winRef.appConfigSite.hosteimageimg + 'images/' + this.winRef.appConfigSite.idEtab + '/upload/' + size + '/';
    }
    ngAfterViewInit() {
        this.cdr.detectChanges(); 0
    }
    changeOffert(value) {
        this.selectRoomEvent.emit(value.id);
        this.selectedItem = value.id;
    }
}